// extracted by mini-css-extract-plugin
export var chip = "_bv-0";
export var filterDropdown = "_bv-5";
export var filterItem = "_bv-6";
export var icon = "_bv-1";
export var removeButton = "_bv-3";
export var removeIcon = "_bv-4";
export var separator = "_bv-2";